export const ROUTE_HOME =   '/';